import { SelectOptions } from '../types/selectOptions.types';

// TODO: Add enum for currencies
export const currencies: SelectOptions[] = [
  { id: 'UYU', value: 'Pesos Uruguayos' },
  { id: 'USD', value: 'Dólares' },
];
